import { getFileFormUrl } from './../../core/helpers/files'
import axios from 'axios'
import { Company } from 'src/core/models'

const KEYS = [
  'representative_id_document',
  'deed_of_incorporation_document',
  'power_of_attorney_document',
  'vat_number_document'
]

const loadDocuments = async (data: any) => {
  for (const key of KEYS) {
    if (data[key]) {
      data[key + '_file'] = await getFileFormUrl(data[key])
      data[key + '_file'].url = data[key]
    }
  }
}

export async function getCompanyDetailsAPI(id: any): Promise<Company> {
  const { data } = await axios.get(`/api/v1/companies/${id}/`)
  await loadDocuments(data)
  return data
}

export async function editCompanyAPI(id: any, payload: any): Promise<Company> {
  const url = `/api/v1/companies/${id}/update_details/`
  const { data } = await axios.patch(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
  await loadDocuments(data)
  return data
}
